export enum RetryCommand {
	Home = "Home",
	Login = "Login",
	CreateAccount = "CreateAccount",
	Payment = "Payment",
	MyLibrary = "MyLibrary",
	StudioAccess = "StudioAccess",
	Settings = "Settings",
}
